var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("modal-pop", {
        staticClass: "modal access-info",
        attrs: {
          opened: this.permissionChk.data == "0",
          modalHeader: true,
          modalFooter: true,
          title: "MMAIN-05-01-01-01"
        },
        on: {
          "update:opened": function($event) {
            return _vm.$set(this.permissionChk, "data == '0'", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", { staticClass: "info-tit" }, [
                  _vm._v(
                    _vm._s(
                      /*KB Global Star Banking 앱에서는 다음 권한이 필요합니다. 필수권한은 반드시 허용해주세요.*/ _vm.$t(
                        "MMAIN-05-01-01-02"
                      )
                    )
                  )
                ]),
                _c("div", { staticClass: "info-cont" }, [
                  _c("p", { staticClass: "info-cont-tit" }, [
                    _vm._v(
                      _vm._s(/*필수 접근 권한*/ _vm.$t("MMAIN-05-01-01-03"))
                    )
                  ]),
                  _c("div", { staticClass: "info-cont-item" }, [
                    _c("p", { staticClass: "item-01" }, [
                      _c("i", { staticClass: "icon icon-save" }),
                      _vm._v(
                        " " +
                          _vm._s(/*저장 공간*/ _vm.$t("MMAIN-05-01-01-04")) +
                          " "
                      )
                    ]),
                    _c("p", { staticClass: "item-02" }, [
                      _vm._v(
                        _vm._s(
                          /*상품 약관, 공지/뉴스 첨부파일 다운로드*/ _vm.$t(
                            "MMAIN-05-01-01-05"
                          )
                        )
                      )
                    ])
                  ]),
                  _c("p", { staticClass: "info-cont-tit" }, [
                    _vm._v(
                      _vm._s(/*선택적 접근 권한*/ _vm.$t("MMAIN-05-01-01-06"))
                    )
                  ]),
                  _c("div", { staticClass: "info-cont-item" }, [
                    _c("p", { staticClass: "item-01" }, [
                      _c("i", { staticClass: "icon icon-camera" }),
                      _vm._v(
                        " " +
                          _vm._s(/*카메라*/ _vm.$t("MMAIN-05-01-01-07")) +
                          " "
                      )
                    ]),
                    _c("p", { staticClass: "item-02" }, [
                      _vm._v(
                        _vm._s(
                          /*QR코드 촬영, 신분증 촬영 등 생체정보등록/검증*/ _vm.$t(
                            "MMAIN-05-01-01-08"
                          )
                        )
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "info-cont-item" }, [
                    _c("p", { staticClass: "item-01" }, [
                      _c("i", { staticClass: "icon icon-photo-gallery" }),
                      _vm._v(
                        " " +
                          _vm._s(/*사진 갤러리*/ _vm.$t("MMAIN-05-01-01-09")) +
                          " "
                      )
                    ]),
                    _c("p", { staticClass: "item-02" }, [
                      _vm._v(
                        _vm._s(/*QR코드 업로드*/ _vm.$t("MMAIN-05-01-01-10"))
                      )
                    ])
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function($event) {
                        return _vm.confirm()
                      }
                    }
                  },
                  [_vm._v(_vm._s(/*확인*/ _vm.$t("MPRS-01-01-01-07")))]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }